import React from 'react';
import { DateRange } from '../../types/dataTypes';
import { useTypewriter } from '../../hooks/useTypewriter';
import { BarChart2, Brain, Target, PieChart as ChartPie, LineChart, TrendingUp } from 'lucide-react';

interface UrlFormProps {
  onAnalyze: (url: string, competitors: string[], dateRange: DateRange) => void;
  isLoading: boolean;
  selectedDateRange: DateRange;
  setSelectedDateRange: (range: DateRange) => void;
}

const UrlForm: React.FC<UrlFormProps> = () => {
  const words = ['Revenue Opportunities', 'Qualified Pipeline', 'Closed/Won Deals', 'More Customers'];
  const { text } = useTypewriter(words, 100, 2000);

  return (
    <div className="relative">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 pt-16">
          <h1 className="text-5xl font-bold text-gray-900 dark:text-white mb-6 leading-tight">
            Turn Competitive Intelligence Into
            <span className="text-blue-600 dark:text-blue-400 block mt-2 min-h-[64px]">
              {text}
            </span>
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We built this customized dashboard specifically for<strong> YOU</strong>. Monitor your competitors' digital presence across LinkedIn and Google Ads. Get actionable insights to optimize your marketing strategy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700">
            <div className="text-blue-600 dark:text-blue-400 font-semibold mb-3 flex items-center">
              <BarChart2 className="w-5 h-5 mr-2" />
              <span>01</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
              Ad Performance
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              Track competitor ad metrics, creative strategies, and campaign performance across platforms.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700">
            <div className="text-blue-600 dark:text-blue-400 font-semibold mb-3 flex items-center">
              <Brain className="w-5 h-5 mr-2" />
              <span>02</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
              Content Analysis
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              Analyze messaging patterns, value propositions, and content strategies that drive results.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700">
            <div className="text-blue-600 dark:text-blue-400 font-semibold mb-3 flex items-center">
              <ChartPie className="w-5 h-5 mr-2" />
              <span>03</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
              Market Insights
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              Get AI-powered recommendations to optimize your marketing strategy and stay ahead.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrlForm;